import React, {useContext} from 'react';
import './vaccinationsbarprofessionals.css';
import {VaccineModel} from '../../../../../model/vaccine.model';
import {ExternalLink} from 'lucide-react';
import {ResultsModel} from '../../../../../model/results.model';
import ResultsContext from '../../../../../store/results-context';

interface VaccinationsBarProfessionalsProps {
    t: (key: string) => string;
    vaccinations: VaccineModel[];
    vaccinationType: string;
    className?: string;
}

const VaccinationsBarProfessionals: React.FC<VaccinationsBarProfessionalsProps> = ({ t, vaccinations, vaccinationType }: VaccinationsBarProfessionalsProps) => {

    const resultsCtx: ResultsModel = useContext(ResultsContext);

    return (
        <div className="vaccinations-professional-bar__wrapper">

            <div className="vaccinations-professional-bar__headers__wrapper">
                <div className="vaccinations-professional-bar__headers-name__wrapper">
                    {t('table_header_name')}
                </div>
                <div className="vaccinations-professional-bar__headers-vaccination-schema__wrapper">
                    {t('table_header_vaccination_schema')}
                </div>
                <div className="vaccinations-professional-bar__headers-chpl__wrapper">
                    {t('table_header_chpl')}
                </div>
                <div className="vaccinations-professional-bar__headers-disclaimer__wrapper">
                    {t('table_header_disclaimer')}
                </div>
                <div className="vaccinations-professional-bar__headers-leaflet__wrapper">
                    {t('table_header_leaflet')}
                </div>
            </div>

            <div className="vaccinations-professional-bar__inner-wrapper">

                <div className="vaccinations-professional-bar_single-vaccine__wrapper">
                    {vaccinations.map((vaccine) => (

                        <div key={vaccine.abbreviation} className="vaccinations-professional-bar_single-vaccine">

                            <div className="vaccinations-professional-bar_name__wrapper">
                                {vaccine.fullName}
                            </div>

                            <div className="vaccinations-professional-bar_vaccination-schema__wrapper">

                                <div className="additional_vertical_space"></div>

                                <div className="vaccinations_bar_professionals__header__wrapper_small_screen">
                                    {t('table_header_vaccination_schema')}:
                                </div>

                                {
                                    (resultsCtx.birthDate_18_to_49 && vaccine.vaccinationSchema_18_49 !== "") &&
                                    vaccine.vaccinationSchema_18_49
                                }
                                {
                                    (resultsCtx.birthDate_50_to_54 && vaccine.vaccinationSchema_50_54 !== "") &&
                                    vaccine.vaccinationSchema_50_54
                                }
                                {
                                    (resultsCtx.birthDate_55_to_59 && vaccine.vaccinationSchema_55_59 !== "") &&
                                    vaccine.vaccinationSchema_55_59
                                }
                                {
                                    (resultsCtx.birthDate_60_to_64 && vaccine.vaccinationSchema_60_64 !== "") &&
                                    vaccine.vaccinationSchema_60_64
                                }
                                {
                                    (resultsCtx.birthDate_over_65 && vaccine.vaccinationSchema_65 !== "") &&
                                    vaccine.vaccinationSchema_65
                                }
                                {
                                    (resultsCtx.pregnancy && vaccine.vaccinationSchema_pregnant !== "") &&
                                    <><br/>{String(vaccine.vaccinationSchema_pregnant)}</>
                                }

                            </div>

                            <div className="vaccinations-professional-bar_chpl__wrapper">

                                <div className="additional_vertical_space"></div>

                                <div className="vaccinations_bar_professionals__header__wrapper_small_screen">
                                    {t('table_header_chpl')}:
                                </div>

                                {vaccine.chpl.map((chplItem, index) => (
                                    <a href={chplItem.url}
                                       key={index}
                                       className="vaccinations-professional__link"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        {chplItem.name} <ExternalLink size={12}/>
                                    </a>
                                ))}
                            </div>


                            <div className="vaccinations-professional-bar_disclaimer__wrapper">

                                {
                                    vaccine.showDisclaimer && <div className="additional_vertical_space"></div>
                                }

                                {
                                    vaccine.showDisclaimer &&
                                    <div className="vaccinations_bar_professionals__header__wrapper_small_screen">
                                        {t('table_header_disclaimer')}:
                                    </div>
                                }

                                {
                                    vaccine.showDisclaimer &&
                                        <div>
                                            {t(`${vaccine.disclaimer}`)}
                                        </div>
                                }
                            </div>

                            <div className="vaccinations-professional-bar_leaflet__wrapper">

                                {
                                    vaccine.leaflet.length > 0 && <div className="additional_vertical_space"></div>
                                }

                                {
                                    vaccine.leaflet.length > 0 &&
                                    <a className="vaccinations-professional__link_leaflet"
                                       href={vaccine.leaflet}
                                       target="_blank"
                                       rel="noreferrer">
                                        {t('leaflet_link')} <ExternalLink size={12}/>
                                    </a>
                                }
                            </div>

                        </div>
                    ))}
                </div>
            </div>

        </div>
    )

}

export default VaccinationsBarProfessionals;
